import { ProfileComponent } from './profile.component';
import { ProfileService } from '@fuse/services/profile.service';
const ɵ0 = ProfileService;
const routes = [
    {
        path: 'profile',
        component: ProfileComponent,
        pathMatch: 'full',
        resolve: {
            data: ɵ0
        }
    }
];
export class ProfileModule {
}
export { ɵ0 };
